import * as React from "react";
import { BrowserRouter as Router, Route } from "react-router-dom";
import {
  EmailContainer,
  HomeContainer,
  ShopContainer,
  SuccessContainer
} from "../../pages";

export const AppRouter = () => {
  return (
    <Router>
      <Route path="/" exact component={HomeContainer} />
      <Route path="/shop" exact component={ShopContainer} />
      <Route path="/success" exact component={SuccessContainer} />
      <Route path="/email" exact component={EmailContainer} />
    </Router>
  );
};
